import React, {FC} from 'react';
import Typography from '@material-ui/core/Typography';

import {getLocale} from '@epic-core/common/dist';
import useLocalization from '../../../../../../hooks/useLocalization';
import {axisPercentFormatter} from '../../utils';

const CODES = {
    label: 'epic.affiliate.fortnite_games.playrate.tooltip.label'
};

export interface PlayrateTooltipLabelParams {
    label: number;
}

const PlayrateTooltipLabel: FC<PlayrateTooltipLabelParams> = ({
    label
}: PlayrateTooltipLabelParams) => {
    const getMessage = useLocalization();
    const locale = getLocale();

    return (
        <Typography
            variant="caption"
            color="textSecondary"
            dangerouslySetInnerHTML={{
                /* Since there is no "react-i18next" package with "Trans" component in the project
                 * we have to use "dangerouslySetInnerHTML" for inline html in translations
                 *  */
                __html: getMessage(CODES.label, [axisPercentFormatter(locale)(label)])
            }}
        />
    );
};

export default PlayrateTooltipLabel;
